import { Check, Clock3, MessageCircle, UsersRound, Video } from "lucide-react";
import Reveal from "@/components/Reveal";
import TidyCalEmbed from "@/components/TidyCalEmbed";

const offerings = [
  {
    id: "group",
    number: "01",
    title: "Group English Practice",
    eyebrow: "LIVE VIRTUAL CLASSROOM",
    price: "$32",
    duration: "90 mins / session",
    path: "myenglishlesson/90-minute-group",
    directUrl: "https://tidycal.com/myenglishlesson/90-minute-group",
    description: "A focused, friendly room to practise the conversations you actually have in Canada.",
    features: [
      { icon: UsersRound, text: "Max 6 Learners per Session" },
      { icon: Video, text: "Live virtual classroom" },
      { icon: MessageCircle, text: "Active conversation focus" },
      { icon: Check, text: "Structured topics" },
    ],
    recommended: true,
  },
  {
    id: "one-on-one",
    number: "02",
    title: "1-on-1 Private Lessons",
    eyebrow: "PERSONALIZED COACHING",
    price: "$55",
    duration: "60 mins / session",
    path: "myenglishlesson/60-minute-lesson",
    directUrl: "https://tidycal.com/myenglishlesson/60-minute-lesson",
    description: "A private lesson shaped around your goals, your voice, and the next conversation that matters.",
    features: [
      { icon: Check, text: "Personalized curriculum" },
      { icon: MessageCircle, text: "Direct instructor feedback" },
      { icon: Clock3, text: "Business and interview prep" },
    ],
  },
];

const PricingSection = () => (
  <section id="pricing-section" className="live-booking-section section-space" aria-labelledby="live-booking-title" data-testid="booking-section">
    <span id="courses-section" className="page-anchor" aria-hidden="true" />
    <span id="booking-section" className="page-anchor" aria-hidden="true" />
    <Reveal className="section-inner">
      <div className="section-heading-row live-booking-heading">
        <div><div className="section-kicker">SINGLE SESSION BOOKINGS</div><h2 id="live-booking-title">Choose your next lesson.</h2></div>
        <p>Pick a live format below and choose a time directly in the TidyCal calendar.</p>
      </div>
      <div className="live-booking-grid">
        {offerings.map((offering) => (
          <article id={offering.id === "group" ? "group-practice" : "private-lesson"} key={offering.id} className={`live-booking-card ${offering.recommended ? "live-booking-card-featured" : ""}`} data-testid={`live-booking-card-${offering.id}`}>
            <div className="live-card-topline"><span>{offering.number}</span><span>{offering.eyebrow}</span>{offering.recommended && <span className="booking-recommendation">BEST FIRST STEP</span>}</div>
            <div className="live-card-title-row"><div><h3>{offering.title}</h3><p>{offering.description}</p></div><div className="live-price"><strong>{offering.price}</strong><span>{offering.duration}</span></div></div>
            <ul className="live-feature-list">{offering.features.map(({ icon: Icon, text }) => <li key={text}><Icon size={16} /> {text}</li>)}</ul>
            <div className="live-embed-heading"><span><span className="live-dot" /> LIVE AVAILABILITY</span><span>Powered by TidyCal</span></div>
            <TidyCalEmbed path={offering.path} title={offering.title} fallbackHref={offering.directUrl} testId={`tidycal-${offering.id}-embed`} />
            <p className="booking-reassurance" data-testid={`booking-reassurance-${offering.id}`}>Single sessions never auto-renew. You pay per class you book, nothing else.</p>
            <p className="booking-policy-note" data-testid={`booking-policy-${offering.id}`}>Plans change — cancel or reschedule free up to 24 hours before class; within 24 hours the session is forfeited.</p>
          </article>
        ))}
      </div>
    </Reveal>
  </section>
);

export default PricingSection;
